import { render, staticRenderFns } from "./TabChangePassword.vue?vue&type=template&id=c199fcc2&"
import script from "./TabChangePassword.js?vue&type=script&lang=js&"
export * from "./TabChangePassword.js?vue&type=script&lang=js&"
import style0 from "./TabChangePassword.scss?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TabChangePassword.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fuseraccount%2FTabChangePassword%2FTabChangePassword.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports